import React from 'react';
import { fetchPut } from '../cruds/remote';
import { UserCheck, UserX, Zap } from 'react-feather';
import PropTypes from 'prop-types';
import getLabel from '../translations/messages';

const ENTITY_NAME = 'users';

const handleDisableUser = (resource, updateResults, toggleModal, locale) => {
  const successMessage = getLabel(locale, 'general.success');
  const errorMessage = getLabel(locale, 'general.errorOccurred');

  toggleModal();

  fetchPut(ENTITY_NAME + '/' + resource.id + '/stateToggle', {})
    .then(() => {
      toggleModal(successMessage, null, false);
      updateResults();
    })
    .catch(() => toggleModal(errorMessage, null, false));
};

export const ToggleEnableButton = ({ resource, toggleModal, updateResults }, context) => {
  const message = resource.enabled ? getLabel(context.locale, 'general.disable') : getLabel(context.locale, 'general.enable');
  const icon = resource.enabled ? <UserX size={18} /> : <UserCheck size={18} />;

  return (
    <span className="CrudButton">
      <span className="tooltip">{message}</span>
      <a name={resource.enabled ? 'disable-user' : 'enable-user'}
         onClick={() => toggleModal(message + '?',
                    () => handleDisableUser(resource, updateResults, toggleModal, context.locale)
                  )}
      >
        {icon}
      </a>
    </span>
  );
};

ToggleEnableButton.contextTypes = {
  locale: PropTypes.string,
};

const handleResetPassword = (resource, updateResults, toggleModal, locale) => {
  const successMessage = getLabel(locale, 'general.success');
  const errorMessage = getLabel(locale, 'general.errorOccurred');

  toggleModal();

  fetchPut(ENTITY_NAME + '/' + resource.id + '/resetPassword', {})
    .then(() => {
        toggleModal(successMessage, null, false);
        updateResults();
    })
    .catch(() => toggleModal(errorMessage, null, false));
};

export const ResetPasswordButton = ({ resource, toggleModal, updateResults }, context) => {
  const message = getLabel(context.locale, 'users.reset');

  return (
    <span className="CrudButton">
      <span className="tooltip">{message}</span>
      <a name="reset-password"
         onClick={() => toggleModal(message + '?',
                    () => handleResetPassword(resource, updateResults, toggleModal, context.locale)
                  )}
      >
        <Zap size={18} />
      </a>
    </span>
  );
};

ResetPasswordButton.contextTypes = {
  locale: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/main/pages/UserButtons.js